import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import BillingReducer from "./reducer";
const Billing = combineReducers({
  billing: BillingReducer,
  form: formReducer,
});

export default Billing;
